module.exports = __webpack_public_path__ + "img/moblyv4-loading.4adbf181.gif";